export function listingStatusLabel(status, aiName = 'Ava') {
  if (!status || status === 'draft') {
    return `Not listed yet — details from your chat with ${aiName}`;
  }
  return status.replace(/_/g, ' ');
}

export function consultationStatusLabel(status) {
  if (status === 'scheduled' || status === 'confirmed') return 'Confirmed';
  if (status === 'confirmation_sent') return 'Confirmed — check your email';
  if (status === 'pending') return 'Requested — awaiting confirmation';
  if (status === 'completed') return 'Completed';
  if (status === 'cancelled') return 'Cancelled';
  if (status === 'no_show') return 'Missed';
  return status || 'Unknown';
}
